// mui
import {Theme} from '@mui/material';

export const MuiTabs = {
	styleOverrides: {
		root: () => ({
			fontWeight: 400,
			letterSpacing: '0.15px',
			height: '44px',
			minHeight: 'unset',
			display: 'flex',
			alignItems: 'center',
			'& .MuiTabs-flexContainer': {
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
			},
			'& .MuiTab-root': {
				color: 'var(--neutral-300)',
				textTransform: 'capitalize',
				textAlign: 'center',
				'&:hover': {
					color: 'var(--primary-500)',
				},
			},
			'& .MuiTabs-indicator': {
				borderRadius: 20,
				fontWeight: 700,
			},
		}),
	},
	variants: [
		{
			props: {indicatorColor: 'primary'} as any,
			style: ({theme}: {theme: Theme}) => ({
				'&.MuiTabs-root': {
					'& .MuiTabs-flexContainer': {
						height: '44px',
						padding: '0 4px',
						background: 'var(--neutral-50)',
						borderRadius: 20,
					},
					'& .MuiTab-root': {
						fontSize: 16,
						padding: '4px 12px ',
						minHeight: '36px',
						'&.Mui-selected ': {
							borderRadius: 20,
							color: theme.palette.primary500,
							fontWeight: 700,
							lineHeight: '28px',
							zIndex: 10,
						},
						'& .MuiTabs-scroller': {
							height: '100%',
						},
					},
					'& .MuiTabs-indicator': {
						boxShadow: 'var(--box-shadow--1)',
						height: '36px',
						bottom: '4px',
						background: 'var(--default-white)',
						zIndex: 1,
					},
				},
			}),
		},
		{
			props: {indicatorColor: 'secondary'} as any,
			style: ({theme}: {theme: Theme}) => ({
				'&.MuiTabs-root': {
					'& .MuiTab-root': {
						padding: '10px 24px',
						height: 40,
						minHeight: 40,
						fontSize: 14,
						fontWeight: 400,
						lineHeight: '20px',
						borderBottom: `1px solid ${theme.palette.neutral300}`,
						'&.Mui-selected ': {
							color: theme.palette.primary900,
							borderBottom: `2px solid ${theme.palette.primary500}`,
							'& > div': {
								marginBottom: '-1px',
							},
							'&:hover': {
								borderBottom: `2px solid ${theme.palette.primary500}`,
							},
						},
						'&:hover': {
							color: theme.palette.primary500,
							borderBottom: `1px solid ${theme.palette.primary500}`,
						},
					},
					'& .MuiTabs-indicator': {
						display: 'none',
					},
				},
			}),
		},
	],
};
